// extracted by mini-css-extract-plugin
export default {"modalOverlay":"WD-z","modalContent":"XD-z","header":"YD-z","close":"ZD-z"};